import React, {useState} from "react"
import {useTranslation} from "next-i18next"
import Typography from "../reusable/Typography/Typography"
import Image from "next/image"
import AccordionAnimation from "../reusable/components/AnimationComponent/AccordionAnimation"

const HowItWorksCheckout = () => {
	const {t} = useTranslation()
	const [isDetailsOpen, setIsDetailsOpen] = useState(false)

	return (
		<div className="pt-5 mb-4 mb-lg-5">
			<div className="d-md-none">
				<div onClick={() => {
					setIsDetailsOpen(isOpen => !isOpen)
				}}
				className="d-flex justify-content-center bg-grey p-3 rounded">
					<Typography className={"me-2"}
						variant="bodyLgBold"
						semanticTag="span">{t("how-it-works")}</Typography>
					<span className="d-flex aligin-itmes-top g-0">
						{isDetailsOpen ?
							<Image src={"/assets/icons/chevron-up-icon.svg"}
								width={18}
								height={18}/> :
							<Image src={"/assets/icons/chevron-down-icon.svg"}
								width={18}
								height={18}/>
						}
					</span>
				</div>
				<div className="pb-3">
					<AccordionAnimation inProp={isDetailsOpen}>
						<div className="bg-grey rounded px-3 pb-2">
							{list.map(({text}, index) => <div key={index}
								className="d-flex mb-3">
								<div style={{width: 24, height: 24, minWidth: 24}}
									className="bg-black d-flex justify-content-center align-items-center me-2 rounded-circle">
									<Typography variant="bodyLgBold"
										className="text-white m-0 p-0">{index + 1}</Typography>
								</div>
								<Typography variant="bodyLg">{t(text)}</Typography>
							</div>)}
						</div>
					</AccordionAnimation>
				</div>
				<hr/>
			</div>

			<div className="d-none d-md-block">
				<Typography variant="heading3">{t("how-it-works")}</Typography>
				<div className="d-flex">
					{list.map(({text}, index) => <div key={index}
						className="d-flex mb-3 col-4">
						<div style={{width: 24, height: 24, minWidth: 24}}
							className="bg-black d-flex justify-content-center align-items-center me-2 rounded-circle">
							<Typography variant="bodyLgBold"
								className="text-white m-0 p-0">{index + 1}</Typography>
						</div>
						<Typography className={`${list.length - 1 === index ? "pe-0" : "pe-3"}`}
							variant="bodyLg">{t(text)}</Typography>
					</div>)}
				</div>
			</div>

		</div>
	)
}

export default HowItWorksCheckout

const list = [
	{
		text: "how-it-works-text-1"
	},
	{
		text: "how-it-works-text-2"
	},
	{
		text: "how-it-works-text-3"
	}
]
